var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-edit-form',{attrs:{"title":_vm.title,"data-service":_vm.dataService,"create-entity":_vm.createEntity,"fields":_vm.fields,"list-route-name":_vm.listRouteName,"item-id":_vm.entityId}})}
var staticRenderFns = []

export { render, staticRenderFns }